export default __webpack_public_path__ + "static/media/Bottles.4280ca25.jpg";